var _excluded = ["className", "text", "children", "href", "icon", "iconPosition", "target"],
  _excluded2 = ["children", "className", "wrapByThree", "wrapByFour", "black"],
  _excluded3 = ["children"],
  _excluded4 = ["children", "className"],
  _excluded5 = ["children", "iconName"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// import { default as Link } from '../../atoms/Link';
import SvgIcon from '../../atoms/SvgIcon/SvgIcon';

/**
 * Status: *finished*
 * Category: FormElements
 *
 * Standard color is black. Labels used with TextBoxWithLabel, TextAreaWithLabel and DropDownListWithLabel should appear on top of input element and be in grey color.
 */

export var Link = function Link(_ref) {
  var _classnames;
  var className = _ref.className,
    text = _ref.text,
    children = _ref.children,
    href = _ref.href,
    icon = _ref.icon,
    iconPosition = _ref.iconPosition,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_self' : _ref$target,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("a", _extends({
    className: classnames('link', (_classnames = {}, _defineProperty(_classnames, "link--with-icon link--".concat(icon), icon), _defineProperty(_classnames, "link--icon-".concat(iconPosition), icon && iconPosition), _defineProperty(_classnames, className, className), _classnames)),
    href: href,
    target: target
  }, rest), text, children);
};
var List = function List(_ref2) {
  var _classnames2;
  var children = _ref2.children,
    className = _ref2.className,
    wrapByThree = _ref2.wrapByThree,
    wrapByFour = _ref2.wrapByFour,
    black = _ref2.black,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  // Determine css classes to use based on the children.
  var childrenArray = React.Children.toArray(children);
  var hasBubbleLinks = childrenArray.find(function (it) {
    return it.type === List.Item && it.props.children.type === List.BubbleLink;
  });
  var hasLinks = !hasBubbleLinks && childrenArray.find(function (it) {
    return it.type === List.Item && it.props.children.type === List.Link;
  });
  return /*#__PURE__*/React.createElement("ul", _extends({
    className: classnames('list', (_classnames2 = {}, _defineProperty(_classnames2, className, className), _defineProperty(_classnames2, 'list--icon-text-links', hasBubbleLinks), _defineProperty(_classnames2, 'list--links', hasLinks), _defineProperty(_classnames2, 'list--black', black), _defineProperty(_classnames2, 'list--wrap list--wrap-by-three', wrapByThree), _defineProperty(_classnames2, 'list--wrap list--wrap-by-four', wrapByFour), _classnames2))
  }, rest), children);
};
List.propTypes = {
  /** Additional classes. */
  className: PropTypes.string,
  /** Whenever this should wrap children by 3 per column. */
  wrapByThree: PropTypes.bool,
  /** Whenever this should wrap children by 4 per column. */
  wrapByFour: PropTypes.bool,
  /** Whenever should children be black. */
  black: PropTypes.bool,
  children: PropTypes.node
};
var Item = function Item(_ref3) {
  var children = _ref3.children,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement("li", _extends({
    className: "list__item"
  }, rest), children);
};
List.Item = Item;
var ListLink = function ListLink(_ref4) {
  var children = _ref4.children,
    className = _ref4.className,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(Link, _extends({
    className: classnames('list__link', _defineProperty({}, className, className))
  }, rest, {
    text: children
  }));
};
List.Link = ListLink;
var BubbleLink = function BubbleLink(_ref5) {
  var children = _ref5.children,
    iconName = _ref5.iconName,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(List.Link, rest, /*#__PURE__*/React.createElement("span", {
    className: "list__link-bubble"
  }, /*#__PURE__*/React.createElement(SvgIcon, {
    iconName: iconName,
    color: "white",
    className: "list__link-icon"
  })), /*#__PURE__*/React.createElement("span", {
    className: "list__link-text"
  }, children));
};
List.BubbleLink = BubbleLink;
List.BubbleLink.propTypes = {
  /** Url of an icon to use. */
  iconSvg: PropTypes.node
};
export default List;